import { h, Component } from 'preact';
import { condClass } from 'utils/utils';
import pure from 'utils/pure';
import s from 'components/shared/preloadThumb/preloadThumb.sss';
import HTML from 'components/core/html/html';
import { ThreeDImage } from 'pages/showtimes_features.js';

const isServer = typeof window === 'undefined';

export default @pure class PreloadThumb extends Component {
	constructor(props) {
		super();

		const defaultUrl = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
		this.state.imgSrc = isServer ? props.src : defaultUrl;
		this.state.showPreload = false;
		if (!isServer) {
			this.img = new Image();
			this.img.onload = this.imageLoaded;
			this.img.onerror = this.imageError;
			this.img.src = props.src;
			setTimeout(() => {
				if (this.state.imgSrc === defaultUrl) {
					// Only show the preload image if connection is really slow
					// and the image really doesn't wanna load in
					// This prevents a weird animation on quick networks
					this.setState({ showPreload: true });
				}
			}, 300);
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.src !== this.props.src) {
			this.img = new Image();
			this.img.onload = this.imageLoaded;
			this.img.src = nextProps.src;
		}
	}

	imageLoaded = () => {
		// Why do we setTimeout ? onload should already be async so nothing to wait for here
		this.setState({ imgSrc: this.props.src });
	};

	imageError = () => {
		if (this.props.fallbackSrc) {
			// a fallback image is provided
			this.setState({ imgSrc: this.props.fallbackSrc });
		}
	};

	render(props) {
		let {
			thumbSrc,
			containerClass,
			class: imgClass,
			fallbackSrc,
			depthMap,
			client = {},
			annotation,
			...imageProps
		} = props;

		const wrapperClass = s.container + condClass(this.state.imgSrc && !isServer, s.loaded) + condClass(containerClass);
		const className = s.img + condClass(imgClass);
		// Display the thumb image first whilst the other image is loading
		let preload;
		if (this.state.showPreload && thumbSrc) {
			preload = (
				<div
					class={s.preload}
					style={{ backgroundImage: `url(${thumbSrc})` }}
					key="preload"
				/>
			);
		}

		let show;
		if (!depthMap) {
			show = <img {...imageProps} class={className} src={this.state.imgSrc} key="image" />;
		} else {
			show = <ThreeDImage {...imageProps} depthMap={depthMap} client={client} parentComp={this.constructor.name.toLowerCase()} key="3d-image" />;
		}

		if (annotation) {
			show = (
				<div class={s.imageWrapper} key="annotation-wrapper">
					{show}
					<HTML class={s.annotation} content={annotation.annotationBody} markdown key="annotation" />
				</div>
			);
		}

		return (
			<div class={wrapperClass}>
				{preload}
				{show}
			</div>
		);
	}
}
